import { createRoute } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';

/**
 * Not authorized. Reached when the API returns 403 for a route the operator typed directly.
 * The client hides links a role cannot use, but hiding is never the control: this screen is
 * what a role sees when they go looking anyway.
 */
function Forbidden() {
  return (
    <div className="o-center">
      <h1 className="o-page-title">Not authorized</h1>
      <p className="o-muted">
        Your role does not have this permission. Every attempt is recorded, which is normal
        and not a problem: ask the owner if you need the access.
      </p>
      <a className="o-btn" href="/">
        Back to Home
      </a>
    </div>
  );
}

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/403',
  component: Forbidden,
});
